import { AutoMap } from "@automapper/classes";
import { TestGroupDTO } from "./test-group.dto";
import { ELIMSProductDTO } from "./ELIMS/elims-product.dto";

export class ProductGroupDTO {
    @AutoMap()
    code: string = ''
    @AutoMap()
    name: string = ''
    @AutoMap(() => TestGroupDTO)
    testGroupList: TestGroupDTO[] = [];
    @AutoMap(() => ELIMSProductDTO)
    elimsProductList: ELIMSProductDTO[] = [];
}